import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import EntityIndicatorDialog from '../EntityIndicatorDialog'
import { Divider, Grid } from '@mui/material'
import IndicatorHeaderDialog from '../IndicatorHeaderDialog'
import IndicatorTable from '../IndicatorTable'
import { shallowEqual, useSelector } from 'react-redux'
import { P154_0, VP_268, VP_185 } from 'rpqs/constants/RpqsConstant'
import { getIndicatorDialogRow, updateIndicatorEntity } from 'rpqs/utils/RPQSUtils'
import { round } from 'lodash'

const DialogP154_0 = ({
    open = false,
    setOpen = () => {},
    title = '',
}) => {
    const {
        rpqs,
        managementEntity,
    } = useSelector(store => ({
        rpqs: store.RpqsReducer.rpqs,
        managementEntity: store.CollectivityReducer.managementEntity,
    }), shallowEqual)

    const [entityDialog, setEntityDialog] = useState(managementEntity)

    useEffect(() => {
        setEntityDialog(managementEntity)
    }, [managementEntity])

    const year = rpqs.year
    const previousYear = year-1
    const currentEntity = entityDialog?.[year]

    const formatedIndicators = [
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_185.code,
            indicatorName: i18n[VP_185.i18n],
            unit: '€ TTC',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_185.code,
                { ...currentEntity?.[VP_185.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            rpqs,
            codeIndicator: VP_268.code,
            indicatorName: i18n[VP_268.i18n],
            unit: '€ TTC',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_268.code,
                { ...currentEntity?.[VP_268.code], value: parseInt(v) || 0 },
            ))),
        }),
    ]

    const onStatusChange = (status) => {
        setEntityDialog(updateIndicatorEntity(entityDialog, year, P154_0.code, { ...currentEntity?.[P154_0.code], status }))
    }

    const getIndicatorValue = (indicator) => (currentEntity?.[indicator?.code]?.value || 0)

    const calculation = () => {
        const calculatedValue = getIndicatorValue(VP_185) != 0 ? round(getIndicatorValue(VP_268) / getIndicatorValue(VP_185) * 100, 2) : 0

        return updateIndicatorEntity(entityDialog, year, P154_0.code, { ...currentEntity?.[P154_0.code], value: calculatedValue })
    }

    return (
        <EntityIndicatorDialog
            open={open}
            setOpen={setOpen}
            title={title}
            hasNote
            entityDialog={entityDialog}
            setEntityDialog={setEntityDialog}
            codeIndicator={P154_0.code}
            calculationOnRegister={calculation}
        >
            <Grid container direction={'column'} gap={2}>
                <IndicatorHeaderDialog
                    current={{
                        year,
                        value: managementEntity?.[year]?.[P154_0.code]?.value,
                    }}
                    previous={{
                        year: previousYear,
                        value: managementEntity?.[previousYear]?.[P154_0.code]?.value,
                    }}
                    status={entityDialog?.[year]?.[P154_0.code]?.status}
                    onStatusChange={onStatusChange}
                    unit={'%'}
                />
                <Divider/>
                <IndicatorTable
                    year={year?.toString()}
                    indicators={formatedIndicators}
                />

            </Grid>
        </EntityIndicatorDialog>
    )
}

DialogP154_0.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
}

export default DialogP154_0
